import FormController from 'controllers/form-controller';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class RegistrationsAccountFormController extends FormController {
  connect() {
    super.connect();

    if (this.downloadLimitModal) {
      triggerCustomEvent(events.show_page.download_limit_modal_connects, {});
      this.initDownloadLimitModal();
    } else if (this.guestDownloadLimitModal) {
      triggerCustomEvent(events.three_download_limit.open);
    }

    if (this.element.getAttribute('data-collections-account-create') === 'true') {
      triggerCustomEvent(events.collections.account_create, {});
    }
  }

  triggerCaptchaAndValidateFields(event) {
    event.preventDefault();
    super.showSpinner();

    window.handleRecaptchaResponse = () => {
      this.validateFields();
      window.handleRecaptchaResponse = null;
    };

    const { recaptchaId } = this.element.querySelector('.recaptcha-holder').dataset;

    window.grecaptcha.reset(recaptchaId);
    window.grecaptcha.execute(recaptchaId);
  }

  checkNewsletterOption() {
    const newsletterOption = document.getElementById('newsletter');

    if (newsletterOption && newsletterOption.checked) {
      sessionStorage.setItem('newsletter_preference', 'newsletter_signup');
    } else {
      sessionStorage.setItem('newsletter_preference', 'no_newsletter_signup');
    }
  }

  validateFields() {
    super.validateFields();

    if (this.formValid) {
      triggerCustomEvent(events.sessions.new_account_created, {
        accountType: 'free',
      });

      this.continueRegistration();
    } else {
      super.hideSpinner();
    }
  }

  continueRegistration() {
    // start: split-test download_limit_modal
    if (this.downloadLimitModal || this.guestDownloadLimitModal) {
      this.element.action = `${this.element.action}?download_limit=true`;
    }
    // end: split-test download_limit_modal

    this.submit();
  }

  initDownloadLimitModal() {
    const modalElem = this.element.closest('[data-controller~="signup-modal"]');

    modalElem.addEventListener('ModalClosed', this.triggerDLModalSeen);
  }

  triggerDLModalSeen() {
    // This extra custom event serves two purposes:
    // 1. to move the event handling to the window object, and
    // 2. so the download-btn-controller doesn't listen for just any modal closing event
    triggerCustomEvent('DownloadLimitModalSeen', {}, window);
  }

  get downloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('ez-session-modal__download-limit');
  }

  // start: split test download_limit_modal
  get guestDownloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('download-limit-form');
  }
  // end: split test download_limit_modal
}
